const inputRecommandations = [
  { title: "AA-A-A-A-ATCHOUM !" },
  { title: "Ariol" },
  { title: "A tout à l'heure Teddie, à tout à l'heure" },
  { title: "ARS GRAMMATICA" },
  { title: "Aria" },
  { title: "Ari, le chasseur" },
];

export default inputRecommandations;
